var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.visibility,attrs:{"id":"spinner"}},[_c('span',{staticClass:"material-icons"},[_vm._v("\n\t\tmotion_photos_on\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }